@if (actions().length) {
    <div class="floating-hub">
        <!-- Action menu -->
        @if (expanded()) {
            <div class="floating-hub-menu" @menuAnimation>
                @for (action of actions(); track action.id) {
                    <button class="floating-hub-action" [matTooltip]="action.label" matTooltipPosition="left" (click)="onAction(action)">
                        <mat-icon [svgIcon]="action.icon" class="icon-size-5"></mat-icon>
                        <span class="floating-hub-action-label">{{ action.label }}</span>
                    </button>
                }
            </div>
        }

        <!-- Main FAB -->
        <button class="floating-hub-trigger" [class.expanded]="expanded()" (click)="toggle()">
            @if (hasUnread() && !expanded()) {
                <span class="floating-hub-badge"></span>
            }
            <mat-icon [svgIcon]="expanded() ? 'heroicons_outline:x-mark' : 'heroicons_outline:chat-bubble-oval-left-ellipsis'" class="icon-size-6 floating-hub-icon"></mat-icon>
        </button>
    </div>
}
